import React, { useEffect } from "react"
import { Link, useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import userAvatar from "../assets/img/img1.jpg";
import notification from "../data/Notification";
import { useAuth } from "../hooks/useAuth";

export default function Header({ onSkin }) {
  const navigate = useNavigate();
  
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const toggleSidebar = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Vérifie si la sidebar est visible ou non
    const isSidebarVisible = document.body.classList.contains("sidebar-show");
    
    if (isSidebarVisible) {
      // Si visible, on la cache
      document.body.classList.remove("sidebar-show");
      document.body.classList.remove("sidebar-hide");
    } else {
      // Si cachée, on l'affiche
      document.body.classList.add("sidebar-show");
      document.body.classList.remove("sidebar-hide");
    }
  }

  // Fonction pour fermer la sidebar
  const closeSidebar = () => {
    if (document.body.classList.contains("sidebar-show")) {
      document.body.classList.remove("sidebar-show");
      document.body.classList.remove("sidebar-hide");
    }
  }

  // Effet pour gérer les clics à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector('.sidebar');
      const menuLink = document.querySelector('.menu-link');
      
      // Vérifie si la sidebar est ouverte
      const isSidebarOpen = document.body.classList.contains("sidebar-show");
      
      if (isSidebarOpen && sidebar && menuLink) {
        // Vérifie si le clic est à l'extérieur de la sidebar et du bouton menu
        const isClickInsideSidebar = sidebar.contains(event.target);
        const isClickOnMenuLink = menuLink.contains(event.target);
        
        if (!isClickInsideSidebar && !isClickOnMenuLink) {
          closeSidebar();
        }
      }
    };
    
    // Gestionnaire pour la touche Echap
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        closeSidebar();
      }
    };
    
    // Ajoute les écouteurs d'événements
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
    
    // Nettoyage
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, []);

  const { isAuthenticated, user, loading: authLoading, logout } = useAuth();

  const handleLogout = async () => {
    logout();
    navigate('/');
  };

  function NotificationList() {
    const notiList = notification.map((item, key) => {
      return (
        <li className="list-group-item" key={key}>
          <div className={(item.status === "online") ? "avatar online" : "avatar"}>{item.avatar}</div>
          <div className="list-group-body">
            <p>{item.text}</p>
            <span>{item.date}</span>
          </div>
        </li>
      )
    });

    return (
      <ul className="list-group">
        {notiList}
      </ul>
    );
  }

  const skinMode = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem('skin-mode', skin);

      onSkin(skin);

    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem('skin-mode');

      onSkin('');
    }
  };

  const sidebarSkin = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    HTMLTag.removeAttribute("data-sidebar");

    if (skin !== "default") {
      HTMLTag.setAttribute("data-sidebar", skin);
      localStorage.setItem("sidebar-skin", skin);
    } else {
      localStorage.removeItem("sidebar-skin", skin);
    }
  };

  return (
    <div className="header-main px-3 px-lg-4">
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
        <i className="ri-menu-2-fill"></i>
      </Link>

      <div className="form-search me-auto">
        <input type="text" className="form-control" placeholder="Rechercher..." />
        <i className="ri-search-line"></i>
      </div>

      <Dropdown className="dropdown-profile ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="avatar online">
            <img src={userAvatar} alt="" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <div className="dropdown-menu-body">
            <div className="avatar avatar-xl online mb-3"><img src={userAvatar} alt="" /></div>

           <h5 className="mb-1 text-dark fw-semibold">
  
    {(() => {
      if (user?.admin_fname || user?.admin_lname) {
        return `${user.admin_fname || ''} ${user.admin_lname || ''}`.trim();
      }
      return user?.full_name || "Administrateur";
    })()}
  
</h5>
             <p className="fs-sm text-secondary">{user?.role?.name}</p>

            <nav className="nav">
              <Link to="/agent/profil"><i className="ri-profile-line"></i> Mon Profile</Link>
            </nav>
            <hr />
            <nav className="nav">
              <a to="" onClick={handleLogout}><i className="ri-logout-box-r-line"></i> Déconnexion</a>
            </nav>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}